"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_jss_1 = __importDefault(require("react-jss"));

exports.default = react_jss_1.default({
  cardImg: {
    width: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: 200
  },
  lg: {
    height: 300
  },
  sm: {
    height: 100
  },
  animatedBackground: {
    animationDuration: '1.25s',
    animationFillMode: 'forwards',
    animationIterationCount: 'infinite',
    animationName: 'placeHolderShimmer',
    animationTimingFunction: 'linear',
    background: 'linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%) #f6f6f6',
    backgroundSize: '800px 104px',
    position: 'relative'
  },
  '@keyframes placeHolderShimmer': {
    '0%': {
      backgroundPosition: '-468px 0'
    },
    '100%': {
      backgroundPosition: '468px 0'
    }
  }
});